import { render } from "./MasterDataRows.vue?vue&type=template&id=31538bc8&scoped=true&ts=true"
import script from "./MasterDataRows.vue?vue&type=script&lang=ts"
export * from "./MasterDataRows.vue?vue&type=script&lang=ts"

import "./MasterDataRows.vue?vue&type=style&index=0&id=31538bc8&lang=scss&scoped=true"
import "./MasterDataRows.vue?vue&type=style&index=1&id=31538bc8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31538bc8"]])

export default __exports__